import { useState, useEffect, useRef } from "react";
import { Check } from "lucide-react";

interface SaveSuccessIndicatorProps {
  isSuccess: boolean;
}

export default function SaveSuccessIndicator({ isSuccess }: SaveSuccessIndicatorProps) {
  const [show, setShow] = useState(false);
  const prevRef = useRef(false);

  useEffect(() => {
    // Detect transition from false → true (each new save)
    if (isSuccess && !prevRef.current) {
      setShow(true);
      const timer = setTimeout(() => setShow(false), 3000);
      prevRef.current = true;
      return () => clearTimeout(timer);
    }
    if (!isSuccess) {
      prevRef.current = false;
    }
  }, [isSuccess]);

  if (!show) return null;

  return (
    <span className="flex items-center gap-1.5 text-sm font-medium text-green-600">
      <Check className="h-4 w-4" />
      Saved
    </span>
  );
}
